import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

/**
 * "N unread messages" — the line WhatsApp draws where the reader left off.
 *
 * Drawn from the unread count captured when the thread was opened, before the
 * mark-read call cleared it (see ConversationView). It stays until the reader
 * switches thread, so a refetch does not make it vanish mid-read.
 */
export default function UnreadDivider({ count }) {
	return (
		<Flex justify="center" my="3" px="4" role="separator" aria-label={`${count} unread messages`}>
			<Text
				fontSize="0.7rem"
				fontWeight="medium"
				color="wa.inkMuted"
				bg="wa.datePill"
				px="3"
				py="1.5"
				borderRadius="md"
				boxShadow="0 1px 0.5px rgba(0,0,0,0.13)"
				textTransform="uppercase"
				letterSpacing="wide"
				w="100%"
				textAlign="center"
				maxW="360px"
			>
				{count} unread {count === 1 ? 'message' : 'messages'}
			</Text>
		</Flex>
	);
}
